import { useCallback, useContext, useEffect, useRef } from 'react';
import { URLStateContext } from '../URLState/URLState';
import getTimeRange from '../../utils/time/getTimeRange';

const useUpdateDateParams = (): void => {
  const { dateFrom, dateTo, duration, updateUrlState } = useContext(URLStateContext);
  const refTimeout = useRef<number>();

  const update = useCallback(() => {
    if (duration !== 'FIXED') {
      const timeRange = getTimeRange(duration);

      if (!dateFrom || !dateTo || dateFrom < timeRange.dateFrom || dateTo < timeRange.dateTo) {
        updateUrlState({
          dateFrom: timeRange.dateFrom,
          dateTo: timeRange.dateTo,
        });
      }
    }

    refTimeout.current = window.setTimeout(update, 1000 * 60);
  }, [dateFrom, dateTo, duration, updateUrlState]);

  useEffect(() => {
    update();

    return () => {
      if (refTimeout.current) {
        window.clearInterval(refTimeout.current);
      }
    };
  }, [update]);
};

export default useUpdateDateParams;
